module.exports = __webpack_public_path__ + "static/media/financial.4fa07eb5.jpg";